import html2canvas from 'html2canvas';

export async function htmlToImage(element: HTMLElement | null) {
  if (!element) return;
  const canvas = await html2canvas(element);
  const data = canvas.toDataURL('image/jpg');

  return data;
}
